import { read } from "./read"

export const swCorporationAccount = {
  read,
}
